import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MainLayout from '../../components/MainLayout';
import { selectors as authSelectors } from '../../reducers/auth';

const mapStateToProps = (state) => ({
  isLoading: authSelectors.getIsLoggingIn(state),
});

export default withRouter(connect(mapStateToProps)(MainLayout));
